import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useRestaurant } from '../context/RestaurantContext';
import { getRestaurantFromStorage } from '../services/restaurant';

// This component now redirects to the new simplified menu view page
export default function ViewMenu() {
  const { restaurantId: contextRestaurantId } = useRestaurant();
  const { menuId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Get restaurant ID from context or localStorage
    let restaurantId = contextRestaurantId;
    if (!restaurantId) {
      const restaurant = getRestaurantFromStorage();
      restaurantId = restaurant?.id;
    }

    if (restaurantId && menuId) {
      // Redirect to new view page
      navigate(`/restaurant/${restaurantId}/menus/${menuId}`, { replace: true });
    } else if (!restaurantId) {
      // No restaurant ID, go to restaurant selection
      navigate('/restaurant-dashboard', { replace: true });
    }
  }, [contextRestaurantId, menuId, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-gray-500">Redirecting...</div>
    </div>
  );
}
